// Flattens the DB-backed Types reference data into plain value lists for enum validation.
// The generated models are inconsistent about which field carries the display value
// (name / description / code / commonName…) — this module is the single place that choice
// lives. NSwag makes every field optional, so blanks are filtered defensively.

import { DataImportReferenceData } from "services/DataImportService";
import { ReferenceListName } from "./validationRuleTypes";

const values = (items: Array<string | undefined> | undefined): string[] =>
  (items ?? []).map((item) => item?.trim() ?? "").filter(Boolean);

export function extractReferenceLists(data: DataImportReferenceData): Record<ReferenceListName, string[]> {
  return {
    AccountTypes: values(data.accountTypes),
    PropertyTypes: values(data.propertyTypes.map((item) => item.description)),
    AccountingBasisTypes: values(data.accountingBasisTypes.map((item) => item.accountingBasisType)),
    PropertyServiceChargeTypes: values(data.propertyServiceChargeTypes.map((item) => item.name)),
    AuthorityToActTypes: values(data.authorityToActTypes.map((item) => item.description)),
    ListedBuildingTypes: values(data.listedTypes.map((item) => item.name)),
    FreeholderCommissionRateTypes: values(data.freeholderCommissionRateTypes.map((item) => item.name)),
    ClientPaymentTypes: values(data.clientPaymentTypes.map((item) => item.description)),
    FundScheduleChargeTypes: values(data.fundScheduleChargeTypes.map((item) => item.name)),
    Countries: values(data.countries.map((item) => item.commonName)),
  };
}
